export default {"src":"/_next/static/image/public/images/phone_icon.46559b5d25be12ec3eb689dac05903a6.svg","height":33,"width":32};